<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{ element ? $t('main.title_edit_element')+":" : $t('main.title_add_element')+":" }}

        {{ this.element_group && this.element_group.data.attributes.name }}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap gap-3">

          <button
            @click="saveClose"
            type="button"
            class="btn btn-small btn-default"
          >
            {{ $t('main.button_save_close') }}
          </button>

          <button
            @click="save"
            type="button"
            class="btn btn-small btn-green"
          >
            {{ $t('main.button_save') }}
          </button>

          <button
            @click="saveCreate"
            type="button"
            class="btn btn-small btn-default"
          >
            <i
              class="fa fa-plus"
              aria-hidden="true"
            ></i>
            {{ $t('main.button_save_create') }}
          </button>

          <router-link
            class="btn btn-small btn-red"
            :to="{
              name: 'landscapings',
              params: {
                slug:
                  this.element_group && this.element_group.data.attributes.slug,
              },
              query: $route.query
            }"
          >{{ $t('main.button_cancel') }}</router-link>

          <button
            @click="saveCopy"
            type="button"
            class="btn btn-small btn-blue"
          >
            {{ $t('main.button_save_copy') }}
          </button>

        </div>
      </template>
    </AdminStickyHeader>
    <div class="form">
      <div class="flex items-start">
        <div class="w-1/3">

          <BaseInput
            id="name"
            :label="$t('main.label_name')"
            v-model="form.name"
            :required="true"
            :errors="errorsFor('name')"
          />

          <BaseInput
            id="article"
            :label="$t('main.label_articul')"
            v-model="form.article"
            :required="false"
            :errors="errorsFor('article')"
          />

          <div class="form-group">
            <label
              for="type_id"
              class="font-bold"
            >{{ $t('main.select_type') }} *:</label>
            <div class="flex items-center">
              <select
                id="type_id"
                v-model="form.type_id"
              >
                <option :value="0">{{ $t('main.type_not_selected') }}</option>
                <option
                  v-for="type in types"
                  :key="type.data.type_id"
                  :value="type.data.type_id"
                >
                  {{ type.data.attributes.name }}
                </option>
              </select>
            </div>
            <ValidationErrors :errors="errorsFor('type_id')" />
          </div>

          <div class="form-group">
            <label class="font-bold">{{ $t('main.label_status') }}: </label>
            <div>
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                type="button"
                @click="form.status = form.status == 1 ? 0 : 1"
              >
                <span class="check"><i
                    v-if="form.status == 1"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{$t('main.published')}}</span>
              </button>
            </div>
          </div>

          <div class="form-group bg-lightblue-border">
            <div class="flex items-center">
              <label
                for="image"
                class="font-bold"
              >{{ $t('main.label_image') }}:
              </label>
              <Hint :text-hint="$t('main.hint_upload_image')" />
            </div>

            <FileInputBlock
              :prefill="imagePreview"
              :selectedImageFileNameDefault="$t('main.image_not_selected')"
              :alreadyLoadText="$t('main.image_selected')"
              :loadedFile="element&&element.data.attributes.image"
              @selected-file="(file) => selectFile(file, 'Image')"
              @remove-file="removeFile('Image')"
            >
              <ValidationErrors :errors="errorsFor('image')" />
            </FileInputBlock>

          </div>
          <div class="form-group bg-lightdarkblue-border">
            <div class="flex items-center">
              <label
                for="texture"
                class="font-bold"
              >{{$t('main.image_texture')}}:
              </label>
              <Hint
                :text-hint="$t('main.hint_upload_image_texture')"
                :bgColor="`bg-red-500`"
              />
            </div>

            <FileInputBlock
              :prefill="texturePreview"
              :selectedImageFileNameDefault="$t('main.image_texture_not_selected')"
              :alreadyLoadText="$t('main.image_texture_selected')"
              :loadedFile="element&&element.data.attributes.texture"
              @selected-file="(file) => selectFile(file, 'Texture')"
              @remove-file="removeFile('Texture')"
            >
              <ValidationErrors :errors="errorsFor('texture')" />
            </FileInputBlock>

          </div>
          <div
            class="form-group bg-lightdarkblue-border"
            v-if="
              element_group.data.attributes.slug == 'plate-ready' ||
              element_group.data.attributes.slug == 'facing' ||
              element_group.data.attributes.slug == 'paving' ||
              element_group.data.attributes.slug == 'border'
            "
          >
            <div class="flex items-center">
              <label
                for="model3d"
                class="font-bold"
              >{{$t('main.3d_model_element')}}*:
              </label>
              <Hint
                :text-hint="$t('main.hint_3d_model_element')"
                :bgColor="`bg-red-500`"
              />
            </div>

            <FileInputBlock
              :prefill="model3dPreview"
              :selectedImageFileNameDefault="$t('main.3d_model_not_selected')"
              :alreadyLoadText="$t('main.3d_model_selected')"
              :loadedFile="element&&element.data.attributes.model3d"
              @selected-file="(file) => selectFile(file, 'Model3d')"
              @remove-file="removeFile('Model3d')"
            >
              <ValidationErrors :errors="errorsFor('model3d')" />
            </FileInputBlock>

          </div>
        </div>
        <div class="w-2/3 ml-30">
          <div class="form-group">
            <div class="font-bold mb-2">{{$t('admin.views.landscaping.sizes_cost')}}*:</div>

            <div
              class="element-sizes-list"
              v-if="
                element_group.data.attributes.slug == 'pour' ||
                element_group.data.attributes.slug == 'grass'
              "
            >
              <div
                class="flex mb-30 element-sizes-list-line items-end no-border"
                v-for="(size, index) in sizes"
                :key="`element-size-${index}`"
              >
                <div class="size-data flex flex-wrap items-end">
                  <div class="size-data-block price mr-30 mb-4">
                    <label
                      class="whitespace-nowrap"
                      :for="`price-${index}`"
                      v-html="$t('main.price_square_metr')"
                    ></label>
                    <input
                      type="number"
                      :id="`price-${index}`"
                      placeholder="0.00"
                      v-model="sizes[index].price"
                    />
                  </div>
                  <div class="size-data-block price mr-30 mb-4 cost-value">
                    <label
                      class="whitespace-nowrap"
                      :for="`cost-${index}`"
                      v-html="$t('main.label_cost_price_currency_kvm')"
                    ></label>
                    <input
                      type="number"
                      :id="`cost-${index}`"
                      placeholder="0.00"
                      v-model="sizes[index].cost"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="element-sizes-list"
              v-if="
                element_group.data.attributes.slug == 'stripe' ||
                element_group.data.attributes.slug == 'plate-fill'
              "
            >
              <div
                class="flex mb-30 element-sizes-list-line items-end no-border"
                v-for="(size, index) in sizes"
                :key="`element-size-${index}`"
              >
                <div class="size-data flex flex-wrap items-end">
                  <div class="cm flex items-end mr-30 mb-4">
                    <div class="size-data-block height">
                      <label :for="`height-${index}`">{{$t('admin.views.landscaping.height_nad_poverh')}}:</label>
                      <input
                        v-model="sizes[index].height"
                        type="number"
                        :id="`height-${index}`"
                        placeholder="0.00"
                      />
                    </div>

                    <div
                      class="size-data-block width ml-30"
                      v-if="element_group.data.attributes.slug == 'stripe'"
                    >
                      <label :for="`width-${index}`">{{$t('main.width_sm')}}:</label>
                      <input
                        v-model="sizes[index].width"
                        type="number"
                        :id="`width-${index}`"
                        placeholder="0.00"
                      />
                    </div>

                    <div class="size-data-block depth ml-30">
                      <label :for="`depth-${index}`">{{$t('admin.views.landscaping.glubina_v_zemlyu_sm')}}:</label>
                      <input
                        v-model="sizes[index].depth"
                        type="number"
                        :id="`depth-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <div class="size-data-block price mr-30 mb-4">
                    <label
                      :for="`price-${index}`"
                      v-html="$t('main.price_cub_metr')"
                    ></label>
                    <input
                      type="number"
                      :id="`price-${index}`"
                      placeholder="0.00"
                      v-model="sizes[index].price"
                    />
                  </div>
                  <div class="size-data-block price mr-30 mb-4 cost-value">
                    <label
                      :for="`cost-${index}`"
                      v-html="$t('main.label_cost_price_currency_cub')"
                    ></label>
                    <input
                      type="number"
                      :id="`cost-${index}`"
                      placeholder="0.00"
                      v-model="sizes[index].cost"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="element-sizes-list"
              v-if="
                element_group.data.attributes.slug == 'plate-ready' ||
                element_group.data.attributes.slug == 'facing' ||
                element_group.data.attributes.slug == 'paving' ||
                element_group.data.attributes.slug == 'border'
              "
            >
              <div
                class="flex mb-30 element-sizes-list-line items-end no-border"
                v-for="(size, index) in sizes"
                :key="`element-size-${index}`"
              >
                <div class="size-data flex items-end flex-wrap">
                  <div class="cm flex items-end mr-30 mb-4">
                    <div class="size-data-block width ml-1">
                      <label :for="`width-${index}`">{{ $t('main.width_sm') }}:</label>
                      <input
                        v-model="sizes[index].width"
                        type="number"
                        :id="`width-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                    <div class="x mb-1 ml-1">X</div>
                    <div class="size-data-block length ml-1">
                      <label :for="`length-${index}`">{{ $t('main.length_sm') }}:</label>
                      <input
                        type="number"
                        :id="`length-${index}`"
                        v-model="sizes[index].length"
                        placeholder="0.00"
                      />
                    </div>
                    <div class="x mb-1 ml-1 mr-1">X</div>
                    <div class="size-data-block height">
                      <label :for="`height-${index}`">{{ $t('main.height_sm') }}:</label>
                      <input
                        v-model="sizes[index].height"
                        type="number"
                        :id="`height-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                    <div
                      class="size-data-block depth ml-30"
                      v-if="element_group.data.attributes.slug == 'border'"
                    >
                      <label :for="`depth-${index}`">{{$t('admin.views.landscaping.glubina_v_zemlyu_sm')}}:</label>
                      <input
                        v-model="sizes[index].depth"
                        type="number"
                        :id="`depth-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                  </div>

                  <div class="size-data-block price mr-30 mb-4">
                    <label
                      v-if="element_group.data.attributes.slug == 'plate-ready'"
                      :for="`price-${index}`"
                      v-html="$t('main.price')+ ', '+$t('main.currency')"
                    ></label>
                    <label
                      :for="`price-${index}`"
                      v-else-if="element_group.data.attributes.slug == 'border'"
                      v-html="$t('main.price')+ ', '+$t('main.currency')+' / '+$t('main.m_p')"
                    ></label>
                    <label
                      v-else
                      :for="`price-${index}`"
                      v-html="$t('main.price_square_metr')"
                    ></label>

                    <input
                      type="number"
                      :id="`price-${index}`"
                      placeholder="0.00"
                      v-model="sizes[index].price"
                    />
                  </div>
                  <div class="size-data-block price mr-30 mb-4 cost-value">
                    <label
                      v-if="element_group.data.attributes.slug == 'plate-ready'"
                      :for="`cost-${index}`"
                      v-html="$t('main.label_cost_price')+ ', '+$t('main.currency')"
                    ></label>
                    <label
                      :for="`cost-${index}`"
                      v-else-if="element_group.data.attributes.slug == 'border'"
                      v-html="$t('main.label_cost_price')+ ', '+$t('main.currency')+' / '+$t('main.m_p')"
                    ></label>
                    <label
                      v-else
                      :for="`cost-${index}`"
                      v-html="$t('main.label_cost_price_currency_kvm')"
                    ></label>

                    <input
                      type="number"
                      :id="`cost-${index}`"
                      placeholder="0.00"
                      v-model="sizes[index].cost"
                    />
                  </div>
                </div>
              </div>
            </div>

            <ValidationErrors :errors="errorsFor('sizes')" />
          </div>

          <div
            class="form-group"
            v-if="
                element_group.data.attributes.slug == 'facing' ||
                element_group.data.attributes.slug == 'paving'
              "
          >
            <div class="font-bold mb-2">{{$t('admin.views.landscaping.fact_sizes_cost')}}:</div>
            <div class="element-sizes-list">
              <div
                class="flex mb-30 element-sizes-list-line"
                v-for="(size, index) in fact_sizes"
                :key="`element-size-${index}`"
              >
                <div class="number-position mr-2 w-4">{{ index + 1 }}.</div>
                <div class="size-data flex items-end flex-wrap">
                  <div class="cm flex items-end mr-30 mb-4">
                    <div class="size-data-block width ml-1">
                      <label :for="`width-${index}`">{{ $t('main.width_sm') }}:</label>
                      <input
                        v-model="size.width"
                        type="number"
                        :id="`width-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                    <div class="x mb-1 ml-1">X</div>
                    <div class="size-data-block length ml-1">
                      <label :for="`length-${index}`">{{ $t('main.length_sm') }}:</label>
                      <input
                        type="number"
                        :id="`length-${index}`"
                        v-model="size.length"
                        placeholder="0.00"
                      />
                    </div>
                    <div class="x mb-1 ml-1 mr-1">X</div>
                    <div class="size-data-block height">
                      <label :for="`height-${index}`">{{ $t('main.height_sm') }}:</label>
                      <input
                        v-model="size.height"
                        type="number"
                        :id="`height-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                  </div>

                </div>
                <div class="size-remove pt-6">
                  <button
                    @click="removeFactSize(size.id)"
                    class="border-sky-blue px-2 rounded"
                    style="height: 36px"
                  >
                    <i class="fas fa-times fa-lg text-red-500"></i>
                  </button>
                </div>
              </div>

              <div class="mb-30 flex pl-6">
                <div>
                  <button
                    class="btn btn-default btn-small"
                    @click="addFactSize"
                  >
                    {{ $t('main.button_add_block_sizes') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="font-bold mb-4 flex items-center">
              {{
                element_group.data.attributes.slug == 'plate-ready'
                  ? $t('admin.views.landscaping.stoimost_podgotovit_rabot_rub')
                  : element_group.data.attributes.slug == 'border'
                    ? $t('admin.views.landscaping.stoimost_podgotovit_rabot_pog')
                    : $t('admin.views.landscaping.stoimost_podgotovit_rabot')
              }}
            </div>
            <div class="flex items-center gap-6">
              <div class="w-28">
                <input
                  type="number"
                  id="price_preparation"
                  v-model="form.price_preparation"
                  :placeholder="0.00"
                />
              </div>
              <div class="flex items-center cost-value gap-4">
                <label
                  v-if="element_group.data.attributes.slug == 'border'"
                  for="cost_preparation"
                  v-html="$t('main.label_cost_price_currency_mp')"
                ></label>
                <label
                  v-else-if="element_group.data.attributes.slug == 'plate-ready'"
                  for="cost_preparation"
                  v-html="$t('main.label_cost_price_currency')"
                ></label>
                <label
                  v-else
                  for="cost_preparation"
                  v-html="$t('main.label_cost_price_currency_kvm')"
                ></label>

                <div class="w-28">
                  <input
                    type="number"
                    id="cost_preparation"
                    v-model="form.cost_preparation"
                    :placeholder="0.00"
                  />
                </div>

              </div>

            </div>
          </div>

          <div
            class="form-group"
            v-if="
              element_group.data.attributes.slug == 'stripe' ||
              element_group.data.attributes.slug == 'plate-fill'
            "
          >
            <div class="font-bold mb-4">{{ $t('admin.views.landscaping.type_rascheta') }}*:</div>
            <div class="flex items-center">
              <input
                type="radio"
                id="individual_size_material_false"
                :checked="form.individual_size_material == 0"
                v-model="form.individual_size_material"
                :value="0"
              />
              <label
                for="individual_size_material_false"
                class="ml-2"
              >{{ $t('admin.views.landscaping.pod_ves_uchastok') }}</label>
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                id="individual_size_material_true"
                :checked="form.individual_size_material == 1"
                v-model="form.individual_size_material"
                :value="1"
              />
              <label
                for="individual_size_material_true"
                class="ml-2"
              >{{ element_group.data.attributes.slug == 'stripe' ? $t('admin.views.landscaping.pod_cvetnik_i_tumby_polosa') : $t('admin.views.landscaping.pod_cvetnik_i_tumby') }}</label>
            </div>
            <div
              class="flex gap-5 mt-2"
              v-if="form.individual_size_material == 1"
            >
              <div>
                <label class="text-sm">{{ $t('admin.views.landscaping.vistup_back') }}</label>
                <input
                  class=" w-24"
                  type="text"
                  v-model="form.vistup_back"
                />
              </div>
              <div>
                <label class="text-sm">{{ $t('admin.views.landscaping.vistup_front') }}</label>
                <input
                  class=" w-24"
                  type="text"
                  v-model="form.vistup_front"
                />
              </div>
              <div>
                <label class="text-sm">{{ $t('admin.views.landscaping.vistup_left') }}</label>
                <input
                  class=" w-24"
                  type="text"
                  v-model="form.vistup_left"
                />
              </div>

              <div>
                <label class="text-sm">{{ $t('admin.views.landscaping.vistup_right') }}</label>
                <input
                  class=" w-24"
                  type="text"
                  v-model="form.vistup_right"
                />
              </div>
            </div>
          </div>

          <div
            class="form-group"
            v-if="element_group.data.attributes.slug == 'facing'"
          >
            <div class="font-bold mb-4 flex">
              {{ $t('admin.views.landscaping.dlya_oblicovki_kakoi_poverhnosti_ispolsuetsya') }}*:
              <Hint :textHint="$t('admin.views.landscaping.hint_dlya_oblicovki_kakoi_poverhnosti_ispolsuetsya')" />
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                id="facing_top"
                :checked="form.facing == 'top'"
                v-model="form.facing"
                :value="'top'"
              />
              <label
                for="facing_top"
                class="ml-2 flex"
              >{{ $t('admin.views.landscaping.top') }}
              </label>
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                id="facing_side"
                :checked="form.facing == 'side'"
                v-model="form.facing"
                :value="'side'"
              />
              <label
                for="facing_side"
                class="ml-2 flex"
              >{{ $t('admin.views.landscaping.side') }}
              </label>
            </div>
            <div class="flex items-center">
              <input
                type="radio"
                id="facing_top_side"
                :checked="form.facing == 'top_side'"
                v-model="form.facing"
                :value="'top_side'"
              />
              <label
                for="facing_top_side"
                class="ml-2 flex"
              >{{ $t('admin.views.landscaping.top_side') }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";

import { v4 as uuidv4 } from "uuid";
import Hint from "../../../shared/components/Hint.vue";

const defaultImagePreview = "/images/design/zaglushka-prevyu.svg";
const defaultModel3dPreview = "/images/design/zaglushka-3d.svg";
const model3dUploaded = "/images/design/3d-model-uploaded.svg";
const defaultTexturePreview = "/images/design/zaglushka-textura.svg";
export default {
  components: { AdminStickyHeader, Hint },
  name: "Form",
  mixins: [validationErrors],
  props: {
    element: {
      type: Object,
    },
    element_group: {
      type: Object,
    },
  },
  data() {
    return {
      model3dUploaded: model3dUploaded,
      imagePreview: this.element
        ? this.element.data.attributes.image || defaultImagePreview
        : defaultImagePreview,
      texturePreview: this.element
        ? this.element.data.attributes.texture || defaultTexturePreview
        : defaultTexturePreview,
      model3dPreview: this.element
        ? (this.element.data.attributes.model3d && model3dUploaded) ||
          defaultModel3dPreview
        : defaultModel3dPreview,
      loadingSaveData: false,
      sizes: [],
      fact_sizes: [],
      form: {
        name: this.element ? this.element.data.attributes.name : "",
        article: this.element ? this.element.data.attributes.article : "",
        type_id: this.element ? this.element.data.attributes.type_id : null,
        status: this.element
          ? parseInt(this.element.data.attributes.status)
          : 1,
        cost_preparation: this.element
          ? this.element.data.attributes.cost_preparation
          : null,
        price_preparation: this.element
          ? this.element.data.attributes.price_preparation
          : null,
        facing: this.element ? this.element.data.attributes.facing : "top",
        selectedImage: null,
        selectedTexture: null,
        selectedModel3d: null,
        vistup_front: this.element
          ? this.element.data.attributes.vistup_front
          : 15,
        vistup_back: this.element
          ? this.element.data.attributes.vistup_back
          : 15,
        vistup_left: this.element
          ? this.element.data.attributes.vistup_left
          : 15,
        vistup_right: this.element
          ? this.element.data.attributes.vistup_right
          : 15,
        individual_size_material: this.element
          ? this.element.data.attributes.individual_size_material
          : 0,
      },
    };
  },
  created() {
    this.sizes = this.$store.state.elements.element_sizes;
    if (this.sizes.length == 0) {
      this.addSize();
    }
    this.fact_sizes =
      (this.element && this.element.data.attributes.fact_sizes) || [];
  },
  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });
  },
  computed: {
    types() {
      return this.$store.state.elements.types;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    async saveClose() {
      const element = await this.saveData();
      if (element) {
        this.$router.replace({
          name: "landscapings",
          params: {
            slug: this.element_group.data.attributes.slug,
          },
          query: { ...this.$route.query },
        });
      }
    },
    async save() {
      const element = await this.saveData();
      if (element) {
        this.$router
          .replace({
            name: "edit_landscaping",
            params: {
              slug: this.element_group.data.attributes.slug,
              element_id: element.element.data.element_id,
            },
            query: { ...this.$route.query },
          })
          .catch((error) => {});
      }
    },

    async saveCreate() {
      const newElement = await this.saveData();
      if (newElement) {
        if (this.$route.name == "add_landscaping") {
          window.location.reload();
        } else {
          await this.$router
            .replace({
              name: "add_landscaping",
              params: {
                slug: this.element_group.data.attributes.slug,
              },
              query: { ...this.$route.query },
            })
            .catch((error) => {});
        }
      }
    },

    async saveCopy() {
      const element = await this.saveData();
      if (element) {
        const clone = await this.$store.dispatch(
          "elements/copySingle",
          element.element.data.element_id
        );

        await this.$router.replace(
          {
            name: "edit_landscaping",
            params: {
              slug: this.element_group.data.attributes.slug,
              element_id: clone.element.data.element_id,
            },
            query: { ...this.$route.query },
          },
          () => {
            location.reload();
          }
        );
      }
    },
    selectFile(file, dataProps) {
      this.form[`selected${dataProps}`] = file;
      this.form[`remove${dataProps}`] = false;
    },
    removeFile(dataProps) {
      this.form[`selected${dataProps}`] = null;
      this.form[`remove${dataProps}`] = true;
    },
    addSize() {
      this.sizes.push({
        id: uuidv4(),
        height: null,
        depth: null,
        length: null,
        width: null,
        price: null,
        cost: null,
      });
    },
    addFactSize() {
      this.fact_sizes.push({
        id: uuidv4(),
        height: null,
        depth: null,
        length: null,
        width: null,
        price: null,
        cost: null,
      });
    },
    removeFactSize(id) {
      this.fact_sizes = this.fact_sizes.filter((size) => size.id != id);
    },

    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;
      try {
        let formDataPost = new FormData();

        if (this.element) formDataPost.append("_method", "PATCH");

        formDataPost.append("name", this.form.name);
        formDataPost.append("article", this.form.article);
        formDataPost.append("type_id", this.form.type_id);
        formDataPost.append("status", parseInt(this.form.status));

        formDataPost.append("vistup_front", this.form.vistup_front);
        formDataPost.append("vistup_back", this.form.vistup_back);
        formDataPost.append("vistup_left", this.form.vistup_left);
        formDataPost.append("vistup_right", this.form.vistup_right);

        formDataPost.append(
          "individual_size_material",
          this.form.individual_size_material
        );

        if (this.form.selectedImage !== null) {
          formDataPost.append("image", this.form.selectedImage);
        }

        if (this.form.selectedModel3d !== null) {
          formDataPost.append("model3d", this.form.selectedModel3d);
        }

        if (this.form.selectedTexture !== null) {
          formDataPost.append("texture", this.form.selectedTexture);
        }

        if (this.form.removeImage) {
          formDataPost.append("remove_image", this.form.removeImage);
        }
        if (this.form.removeModel3d) {
          formDataPost.append("remove_model3d", this.form.removeModel3d);
        }
        if (this.form.removeTexture) {
          formDataPost.append("remove_texture", this.form.removeTexture);
        }

        if (this.form.price_preparation !== null) {
          formDataPost.append("price_preparation", this.form.price_preparation);
        }

        if (this.form.cost_preparation !== null) {
          formDataPost.append("cost_preparation", this.form.cost_preparation);
        }

        if (this.form.facing !== null) {
          formDataPost.append("facing", this.form.facing);
        }

        if (this.sizes.length > 0) {
          this.sizes.forEach((size, index) => {
            formDataPost.append(`sizes[${index}][id]`, size.id);
            if (size.height) {
              formDataPost.append(`sizes[${index}][height]`, size.height);
            }
            if (size.depth) {
              formDataPost.append(`sizes[${index}][depth]`, size.depth);
            }
            if (size.length) {
              formDataPost.append(`sizes[${index}][length]`, size.length);
            }
            if (size.width) {
              formDataPost.append(`sizes[${index}][width]`, size.width);
            }
            formDataPost.append(`sizes[${index}][price]`, size.price);
            formDataPost.append(`sizes[${index}][cost]`, size.cost);
            formDataPost.append(
              `sizes[${index}][cost_coefficient]`,
              size.cost_coefficient
            );
          });
        }

        if (this.fact_sizes.length > 0) {
          this.fact_sizes.forEach((size, index) => {
            formDataPost.append(`fact_sizes[${index}][id]`, size.id);
            if (size.height) {
              formDataPost.append(`fact_sizes[${index}][height]`, size.height);
            }
            if (size.depth) {
              formDataPost.append(`fact_sizes[${index}][depth]`, size.depth);
            }
            if (size.length) {
              formDataPost.append(`fact_sizes[${index}][length]`, size.length);
            }
            if (size.width) {
              formDataPost.append(`fact_sizes[${index}][width]`, size.width);
            }
            formDataPost.append(`fact_sizes[${index}][price]`, size.price);
            formDataPost.append(`fact_sizes[${index}][cost]`, size.cost);
            formDataPost.append(
              `fact_sizes[${index}][cost_coefficient]`,
              size.cost_coefficient
            );
          });
        }

        let url = `/api/admin/elements/${this.element_group.data.attributes.slug}`;
        if (this.element)
          url = `/api/admin/elements/${this.element_group.data.attributes.slug}/${this.element.data.element_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
        return res.data;
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (error.response) {
          const notification = {
            type: "error",
            message:
              error.response &&
              error.response.data &&
              error.response.data.message,
          };
          this.$store.dispatch("notification/add", notification, {
            root: true,
          });
        }
      } finally {
        this.loadingSaveData = false;
      }
    },
  },
};
</script>
<style scoped>
.price label {
  white-space: nowrap;
}
</style>
